import type { Maybe, ReferralCouponFragment } from '@drycut/graphql';

import { Heading, Para, Stack } from '@drycut/ui-components';

import CutNowButton from '../CutNowButton';
import ExpirationDate from '../ExpirationDate';
import { InputFieldCopier } from '../InputFieldCopier';
import { InvalidCoupon } from '../InvalidCoupon';
import Action from './Action';
import RedemptionSteps from './RedemptionSteps';

type Props = {
  coupon?: Maybe<ReferralCouponFragment>;
};

export function Redemption({ coupon }: Props): React.ReactElement {
  const validCoupon = coupon?.type === 'Coupons::NewCustomerReferral' && !coupon.expired;

  if (!validCoupon) {
    return <InvalidCoupon couponExpired={!!coupon?.expired} expiresAt={coupon?.expiresAt} />;
  }

  return (
    <Stack gap={6} className="items-center text-center text-pretty">
      <Heading variant="h2">13 CHF Gutschein für Deinen ersten DRYCUT</Heading>

      <Stack gap={2}>
        <Para>
          {coupon.customer?.name} schenkt Dir einen{' '}
          <strong className="font-aribaubold">13 CHF Gutschein</strong> von DRYCUT. Damit bekomst Du
          Deinen ersten DRYCUT für 29 CHF statt 42 CHF.
        </Para>

        <RedemptionSteps coupon={coupon} />

        <Stack gap={4} className="my-4">
          <Action title="Direkt einlösen">
            <CutNowButton couponCode={coupon.code} width={52} className="items-start" />
          </Action>

          <Action title="Gutscheincode">
            <InputFieldCopier textToCopy={coupon.code} className="max-w-52 tracking-wider" />
          </Action>
        </Stack>

        <ExpirationDate couponExpiration={coupon.expiresAt} />
      </Stack>
    </Stack>
  );
}
